module.exports = __webpack_public_path__ + "images/tile-summer-7944e05d08eb381363417c3e2abc5eb9.png";